module.exports = __webpack_public_path__ + "img/YingGong.dcff29e7.jpg";